import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgModule,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MediaImageComponent,
  MediaSvgComponentModule,
} from '@nx-icilalune/icilalune/media';
import { Solution } from '@nx-icilalune/data/icilalune/types';
import { GetEntityPipe } from '@nx-icilalune/data/access';
import { LetModule, PushModule } from '@ngrx/component';
import { ImageMedia } from '@nx-icilalune/drupal-types';
import { ComponentStore } from '@ngrx/component-store';
import { filter, map, switchMap, take } from 'rxjs';

interface SolutionBlockComponentStore {
  solution?: Solution;
  thumbnail?: ImageMedia;
}

@Component({
  selector: 'i2l-ui-solution-block',
  template: `
    <ng-container *ngrxLet="thumbnail$; let thumbnail">
      <ng-container *ngIf="thumbnail">
        <i2l-media-image [image]="thumbnail"></i2l-media-image>
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./solution-block.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionBlockComponent extends ComponentStore<SolutionBlockComponentStore> {
  readonly solution$ = this.select((s) => s.solution);
  readonly thumbnail$ = this.select((s) => s.thumbnail);

  @Input()
  set solution(solution: Solution) {
    this.patchState({ solution });
  }

  constructor(private getEntityPipe: GetEntityPipe) {
    super({});
    this.patchState(
      this.solution$.pipe(
        filter((solution) => !!solution),
        switchMap((solution) => {
          return this.getEntityPipe
            .transform<ImageMedia>(solution?.thumbnail?.id)
            .pipe(
              map((imageMedia) => {
                return { thumbnail: imageMedia };
              }),
              take(1)
            );
        }),
        take(1)
      )
    );
  }
}

@NgModule({
  imports: [
    CommonModule,
    MediaSvgComponentModule,
    GetEntityPipe,
    PushModule,
    LetModule,
    MediaImageComponent,
  ],
  declarations: [SolutionBlockComponent],
  exports: [SolutionBlockComponent],
})
export class SolutionBlockComponentModule {}
